<template>
  <div class="chart-data-page-content common-title-page">
    <div class="title-wrapper">
      <pods-input ref="podsInput"></pods-input>
      <span class="title">{{ $t('text.chart_pod_capacitance_readings') }}</span>
      <div class="status-table">
        <UtcOffsets />
        <el-table :data="statusData" border size="mini" class="w-242 mt-10">
          <el-table-column prop="key" label=""></el-table-column>
          <el-table-column
            prop="value"
            :label="$t('text.status')"
          ></el-table-column>
        </el-table>
      </div>
    </div>
    <div class="page-content">
      <div class="stats-timer-row">
        <el-table :data="sensorData" border size="mini" class="median-table">
          <el-table-column prop="key" label=""></el-table-column>
          <el-table-column
            prop="sensor1"
            :label="firstLetterCapitalize($t('text.sensor') + ' 1')"
          ></el-table-column>
          <el-table-column
            prop="sensor2"
            :label="firstLetterCapitalize($t('text.sensor') + ' 2')"
          ></el-table-column>
        </el-table>
        <div class="circle-box">
          <div class="circle-ring v-h-center">
            0:{{ countDown > 9 ? countDown : '0' + countDown }}
          </div>
          <div class="latest-time-block">
            <div class="latest-time-label">{{ $t('text.latest_time') }}</div>
            <div class="latest-time-val">
              {{
                latestTime
                  ? moment
                      .utc(latestTime)
                      .tz($store.state.pods.selectedUtcOffset)
                      .format('YYYY-MM-DD HH:mm:ss')
                  : '--'
              }}
            </div>
          </div>
        </div>
      </div>
      <div class="chart-section-label">
        {{ $t('text.recent_data_for') }}
      </div>
      <div id="echarts" style="width: 100%"></div>
    </div>
  </div>
</template>

<script>
import PodsInput from '@/components/PodsInput'
import UtcOffsets from '@/components/UtcOffsets'
import moment from 'moment'
export default {
  data() {
    return {
      moment: moment,
      chart: '',
      option: {},
      source: [['timeStamp', 'sensor1', 'sensor2', 'agg'], ['', 0, 0, 0]]
    }
  },
  props: {
    latestCaliPodChartDataPoint: {
      type: Object,
      required: true
    },
    countDown: {
      type: Number,
      required: true
    },
    sensorData: {
      type: Array,
      required: true
    },
    latestTime: {
      type: String
    }
  },
  computed: {
    statusData() {
      return [
        {
          key: this.$t('text.battery'),
          value:
            typeof this.latestCaliPodChartDataPoint.batteryValue !== 'undefined'
              ? this.latestCaliPodChartDataPoint.batteryValue + '%'
              : '--'
        },
        {
          key: this.$t('text.connection'),
          value:
            typeof this.latestCaliPodChartDataPoint.connectionStatus !==
            'undefined'
              ? this.latestCaliPodChartDataPoint.connectionStatus
              : '--'
        }
      ]
    }
  },
  components: {
    PodsInput,
    UtcOffsets
  },
  mounted: function() {
    this.initChart()
  },
  watch: {
    '$store.state.pods.selectedPod': function() {
      this.source = [['timeStamp', 'sensor1', 'sensor2', 'agg'], ['', 0, 0, 0]]
      this.initChart()
    },
    '$store.state.locale.currentLocale': function() {
      this.initStatusData()
    }
  },
  methods: {
    initStatusData() {
      this.statusData[0].key = this.$t('text.battery')
      this.statusData[1].key = this.$t('text.connection')
    },
    firstLetterCapitalize(val) {
      return val.charAt(0).toUpperCase() + val.slice(1)
    },
    updateChart() {
      //Remove initialization data
      let vm = this
      if (this.source[1][0] === '') {
        this.source.splice(1, 1)
      }
      let time = moment(this.latestCaliPodChartDataPoint.timeStamp).format(
        'YYYY-MM-DD HH:mm:ss'
      )
      this.source.push([
        time,
        this.latestCaliPodChartDataPoint.sensor1,
        this.latestCaliPodChartDataPoint.sensor2,
        this.latestCaliPodChartDataPoint.agg
      ])

      this.source.forEach((item, index) => {
        //Remove more than 15 minutes data
        if (index > 0) {
          let timeDiff =
            vm.source[1][0] !== ''
              ? moment(time).diff(moment(item[0]), 'minutes')
              : 0
          if (timeDiff >= 15) {
            vm.source.splice(index, 1)
          }
        }
      })
      this.option.dataset.source = this.source
      this.chart.setOption(this.option)
    },
    initChart() {
      var dom = document.getElementById('echarts')
      this.chart = this.echarts.init(dom)
      this.option = {
        grid: {
          left: 0,
          right: 30,
          bottom: 50,
          top: 20,
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          formatter(params) {
            let tooltipStr = `<div>${moment(params[0].axisValue)
              .add(
                moment.tz(vm.$store.state.pods.selectedUtcOffset).utcOffset() /
                  60,
                'hours'
              )
              .format('DD/MM/YY HH:mm:ss')}</div>`
            params.forEach(item => {
              if (tooltipStr.indexOf(item.color) < 0) {
                tooltipStr =
                  tooltipStr +
                  `<div><div style="display:inline-block; margin-right: 5px; width: 10px; height: 10px; border-radius: 5px; background-color:${
                    item.color
                  }"></div>${item.seriesName} : ${
                    item.value[item.seriesIndex + 1]
                  }</div>`
              }
            })
            return tooltipStr
          }
        },
        color: ['#008ffb', '#00e396', '#f29f26'],
        legend: {
          x: 'center',
          y: 'bottom',
          data: [
            this.$t('text.sensor') + ' 1',
            this.$t('text.sensor') + ' 2',
            this.$t('text.aggregate')
          ]
        },
        dataZoom: [
          {
            show: true,
            height: 25,
            bottom: 25,
            start: 0,
            zoomOnMouseWheel: true,
            moveOnMouseMove: true
          },
          {
            type: 'inside'
          }
        ],
        dataset: {
          dimensions: ['timeStamp', 'sensor1', 'sensor2', 'agg'],
          source: this.source
        },
        xAxis: [
          {
            type: 'time',
            splitLine: {
              show: false
            },
            axisLabel: {
              formatter: function(value) {
                let time = value
                  ? moment(value).add(
                      moment
                        .tz(vm.$store.state.pods.selectedUtcOffset)
                        .utcOffset() / 60,
                      'hours'
                    )
                  : ''
                return time.format('HH:mm:ss') + '\n' + time.format('DD/MM/YY')
              }
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            nameLocation: 'center',
            nameGap: 40,
            axisLine: {
              show: false
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: ['#f2f2f2'],
                width: 1,
                type: 'solid'
              }
            }
          }
        ],
        series: [
          {
            name: this.$t('text.sensor') + ' 1',
            type: 'line',
            symbol: 'circle',
            encode: {
              x: 'timeStamp',
              y: 'sensor1'
            }
          },
          {
            name: this.$t('text.sensor') + ' 2',
            type: 'line',
            symbol: 'circle',
            encode: {
              x: 'timeStamp',
              y: 'sensor2'
            }
          },
          {
            name: this.$t('text.aggregate'),
            type: 'line',
            symbol: 'circle',
            encode: {
              x: 'timeStamp',
              y: 'agg'
            }
          }
        ]
      }
      this.chart.setOption(this.option)
      let vm = this
      window.addEventListener('resize', function() {
        vm.chart.resize()
      })
    }
  }
}
</script>
